import { Box } from '@coolblue-development/becky';
import LogoNL from '../../../assets/logoSubsidiaryNL.svg';
import LogoBE from '../../../assets/logoSubsidiaryBE.svg';
import LogoDE from '../../../assets/logoSubsidiaryDE.svg';
import GarlandNL from '../../../assets/garlandSubsidiaryNL.svg';
import GarlandDEBE from '../../../assets/garlandSubsidiaryDEBE.svg';
import { useSubsidiary } from '../../../utils/hooks/useSubsidiary';

const subsidiaryLogoMap = {
  nl: LogoNL,
  be: LogoBE,
  de: LogoDE
} as const;

const subsidiaryGarlandMap = {
  nl: GarlandNL,
  be: GarlandDEBE,
  de: GarlandDEBE
} as const;

const CatoLogo = (props: React.SVGProps<SVGSVGElement>): JSX.Element => {
  const subsidiary = useSubsidiary();
  const Logo = subsidiaryLogoMap[subsidiary] as unknown as React.ComponentType<React.SVGProps<SVGSVGElement>>;
  const Garland = subsidiaryGarlandMap[subsidiary] as unknown as React.ComponentType<React.SVGProps<SVGSVGElement>>;

  return (
    <Box sx={{ position: 'relative', display: 'inline-flex', alignItems: 'center' }}>
      <Garland
        style={{
          position: 'absolute',
          top: '-5px',
          left: '-80%',
          zIndex: 0,
          pointerEvents: 'none'
        }}
      />
      <Logo {...props} style={{ position: 'relative', zIndex: 1, width: '55px' }} />
    </Box>
  );
};

export default CatoLogo;
